import { Component, Input, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'suvo-bi-skeleton-legend',
  templateUrl: './skeleton-legend.component.html',
  styleUrls: ['./skeleton-legend.component.scss'],
})
export class SkeletonLegendComponent implements OnInit {
  @Input() legendCount = 8;

  legend: string[];

  ngOnInit() {
    const legend: string[] = [];

    for (let i = 0; i < this.legendCount; i++) {
      legend.push(`${this.randomBetween(60, 140)}px`);
    }

    this.legend = legend;
  }

  randomBetween(min: number, max: number) {
    return min + (max - min) * Math.random();
  }
}
